import { useCallback } from 'react';

import {
  useBrandVoicesActions,
  useCustomerActions,
  useCustomerCanCreateFeatureItem,
  useNotificationActions,
  useWorkspaceActions,
} from 'src/store';
import { useHistory } from 'src/lib/hooks';
import { ROUTES } from 'src/routes';
import { useUpgradePopup } from 'src/services/popup';
import { FEATURE_LIMITS } from 'src/data/featureLimits';

export const useHandlers = ({ onClose, validate, id, name }) => {
  const history = useHistory();
  const notifications = useNotificationActions();
  const workspaceActions = useWorkspaceActions();
  const customerActions = useCustomerActions();
  const brandVoicesActions = useBrandVoicesActions();
  const openUpgradePopup = useUpgradePopup();
  const customerCanCreateBrandVoice = useCustomerCanCreateFeatureItem(
    FEATURE_LIMITS.brandVoicePerCustomer
  );

  const handleSubmit = useCallback(async () => {
    if (!validate()) {
      return;
    }
    if (id) {
      await brandVoicesActions.updateBrandVoice(id, name);
      workspaceActions.refreshCurrentWorkspace();
      notifications.displaySuccess(`Brand voice '${name}' updated`);
    } else {
      if (!customerCanCreateBrandVoice) {
        openUpgradePopup(FEATURE_LIMITS.brandVoicePerCustomer);
        return;
      }
      const brandVoice = await brandVoicesActions.createBrandVoice(name);
      workspaceActions.refreshCurrentWorkspace();
      if (brandVoice) {
        notifications.displaySuccess(`Brand voice '${brandVoice.name}' created`);
      }
      history.push(`${ROUTES.BRAND_VOICE}/${brandVoice.id}${ROUTES.TONE_OF_VOICE}`);
    }
    customerActions.refreshCurrentCustomerFeatureLimit();
    onClose();
  }, [
    validate,
    customerCanCreateBrandVoice,
    openUpgradePopup,
    brandVoicesActions,
    id,
    name,
    onClose,
    notifications,
    history,
    customerActions,
    workspaceActions,
  ]);

  return { handleSubmit };
};
